import { takeLatest } from 'redux-saga/effects'
import { LOAD_WHITELABEL } from 'app/redux-base/actions/configurator'
import loadWL from './loadWL'

export default function* watchLoadWL() {
  yield takeLatest(LOAD_WHITELABEL.REQUEST, loadWL)
}
